export default Object.freeze({
  list: [],
  info: {},
  visits: [],
  visitInfo: {},
  sites: [],
  visitors: [],
});
